import type { Ref } from 'vue'

export const AD_PARAMS_STATE_KEY = 'ad-params:search'

export const useAdParams = (): Ref<string> => useState<string>(AD_PARAMS_STATE_KEY, () => '')
